import BaseService from '@/services/BaseService';

class UserProfileService extends BaseService {
    submitNewPassword = (data) => this.post('/agency/changepassword', data);
}

export default new UserProfileService();
